import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {

  @HostBinding('class') get class() {
    let _class = [];
    if(this.button) _class.push(`ion-activatable ripple-parent`);
    if(this.color) _class.push(`ion-color-${this.color}`);
    return _class.join(' ');
  }

  @Input() button:boolean = true;
  @Input() color:string = "white";
  @Input() href:string;
  @Input() download:string;

  constructor(
  ) { }

  ngOnInit() {}
}